module.exports = __webpack_public_path__ + "static/media/floor_sw.4529a1ad.png";